<div fxLayout="column" fxFlex="0 0 100%" class="hr-notes-wrapper">
    <app-table-filter-expansion-panel class="task-expansion" #filterExpansion [hasTopBorder]="false">
        <app-table-filter
            [cacheScope]="cacheScope"
            [filtersTogglesInOnBtn]="true"
            [inGlobalFilter]="true"
            color="accent"
            #filter
        >
            <app-table-search
                toggleBtnLabel="File"
                i18n-toggleBtnLabel
                [inGlobalFilter]="true"
                class="align-space"
                searchFilterRef
            ></app-table-search>

            <app-tag-chip-search-filter
                [inGlobalFilter]="true"
                fxFlex="50%"
                fxFlex.lt-md="100%"
                fxLayoutAlign="start"
                tagsFilterRef
            ></app-tag-chip-search-filter>
            <app-select-filter
                [inGlobalFilter]="true"
                class="filter-space"
                label="Prio"
                i18n-label="@@prio"
                [property]="GlobalFilterProperty.TASK_PRIO"
                [options]="filePrioOptions"
                taskPrioRef
            ></app-select-filter>
        </app-table-filter>
    </app-table-filter-expansion-panel>
    <!-- <mat-progress-bar
        class="progress-table-loader"
        *ngIf="(dataSource.status | async) === 'loading'"
        mode="indeterminate"
    ></mat-progress-bar> -->
    <mat-table
        #table
        [dataSource]="dataSource"
        matSortActive="created_at"
        matSortDirection="desc"
        matSort
        multiTemplateDataRows
    >
        <ng-container matColumnDef="title">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Name</span>
                </div>
            </mat-header-cell>
            <mat-cell [ngClass]="{ 'a1-name': file.priority == 'a1' }" *matCellDef="let file">
                <span class="mobile-label" i18n>Name:</span>
                <app-row-hover-actions [showActions]="columns.includes('tools')">
                    <span class="notes">{{ file.title }}</span>
                    <!-- <button
                        rowHoverAction
                        mat-icon-button
                        [disabled]="!authUser?.canEditMedia(file)"
                        (click)="edit(file)"
                        matTooltip="View"
                        i18n-matTooltip="@@view"
                        aria-label="View"
                        i18n-aria-label="@@view"
                    >
                        <mat-icon>visibility</mat-icon>
                    </button> -->
                    <button
                        rowHoverAction
                        mat-icon-button
                        [disabled]="!authUser?.canEditMedia(file)"
                        (click)="edit(file)"
                        matTooltip="Edit"
                        i18n-matTooltip="@@edit"
                        aria-label="Edit"
                        i18n-aria-label="@@edit"
                    >
                        <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </button>
                    <button
                        rowHoverAction
                        mat-icon-button
                        (click)="delete(file)"
                        matTooltip="Delete"
                        i18n-matTooltip="@@delete"
                        aria-label="Delete"
                        i18n-aria-label="@@delete"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button
                        rowHoverAction
                        mat-icon-button
                        [disabled]="!file.medias?.file?.length"
                        (click)="copyLink(file)"
                        matTooltip="Copy link"
                        i18n-matTooltip="@@copyLink"
                        aria-label="Copy link"
                        i18n-aria-label="@@copyLink"
                    >
                        <mat-icon>link</mat-icon>
                    </button>
                    <div *ngIf="file.downloads" rowHoverAction class="download-wrapper">
                        <span *ngIf="!!file.medias?.file?.length" class="files-count">{{
                            file.medias?.file?.length
                        }}</span>
                        <button
                            (click)="download(file)"
                            matTooltip="Download"
                            mat-icon-button
                            i18n-matTooltip="@@download"
                            aria-label="Download"
                            i18n-aria-label="@@download"
                            class="comment-add"
                        >
                            <mat-icon>file_download</mat-icon>
                        </button>
                    </div>
                    <button
                        rowHoverAction
                        (click)="createMaterial(file)"
                        matTooltip="Create material"
                        mat-icon-button
                        i18n-matTooltip="@@createMaterial"
                        aria-label="Create material"
                        i18n-aria-label="@@createMaterial"
                        class="creat-mat"
                    >
                        <mat-icon
                            fxFlex="0 0 auto"
                            color="primary"
                            fontSet="klickdata"
                            fontIcon="kd-icon-document"
                            class="course-plan-icon kd-icon-24 no-shadow"
                        ></mat-icon>
                    </button>
                </app-row-hover-actions>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="created_at">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Created at</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span>{{ file.created_at | kdDateFormat : 'YYMMDD_HHmm' }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="updated_at">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Last edit</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span>{{ file.updated_at | kdDateFormat : 'YYMMDD_HHmm' }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="description">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n="@@description">Description</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span>{{ file.description }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="favorite">
            <mat-header-cell *matHeaderCellDef>
                <mat-icon
                    (click)="filterFavorite = !filterFavorite; onFilterFavoriteClick()"
                    mat-icon-button
                    [ngStyle]="{ color: '#bfd8d0' }"
                    class="grey favorite-button"
                    matTooltip="Filter Favorite"
                    i18n-matTooltip="@@filterFavorite"
                    >{{ filterFavorite ? 'star' : 'star_border' }}</mat-icon
                >
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span i18n="@@favorite" *ngIf="isMobile" class="mobile-label"> Favorite </span>
                <mat-icon
                    i18n-matTooltip="@@favorite"
                    (click)="$event.stopPropagation(); favoriteResource(file)"
                    [ngStyle]="{ color: '#bfd8d0' }"
                    class="grey favorite-button"
                    matTooltip="Favorite"
                    >{{ file.favorite ? 'star' : 'star_border' }}</mat-icon
                >
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="visibility">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Status</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <div
                    class="visibility-cell"
                    fxLayoutAlign="start center"
                    fxLayoutGap="5px"
                    [ngClass]="{
                        darkblue: media.visibility == 'public',
                        grey: media.visibility == 'private',
                        iceblue: media.visibility == 'academy'
                    }"
                >
                    <mat-icon
                        [ngClass]="{
                            darkblue: media.visibility == 'public',
                            grey: media.visibility == 'private',
                            iceblue: media.visibility == 'academy'
                        }"
                        [matTooltip]="getVisibilityTooltip(media)"
                    >
                        {{
                            media.visibility == 'public'
                                ? 'public'
                                : media.visibility == 'private'
                                ? 'public_off'
                                : media.visibility == 'users'
                                ? 'people'
                                : media.visibility == 'groups'
                                ? 'group'
                                : 'published_with_changes'
                        }}
                    </mat-icon>

                    <!-- <span>{{ media.visibility }}</span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="tags">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Tags</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span *ngIf="isMobile" class="mobile-label" i18n> Tags </span>
                <app-table-tags-on-the-fly
                    (click)="$event.stopPropagation()"
                    [tags]="file.tags"
                    [canRemoveTags]="true"
                    (onUpdateTags)="file.id && updateFileTags(file, $event)"
                    (onTagClick)="onTagClick($event)"
                ></app-table-tags-on-the-fly>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="author">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Creator</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Creator:</span>
                <span class="author-name" *ngIf="file.author?.name" [matTooltip]="file.author?.name">{{
                    file.author?.name | nameSign
                }}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="shared_with">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Shared</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Shared with:</span>
                <ng-container *ngIf="!!getManagersWithoutAuthor(file)?.length">
                    <ng-container *ngIf="getManagersWithoutAuthor(file).length < 3">
                        <ng-container *ngFor="let manager of getManagersWithoutAuthor(file); let isLast = last">
                            <span
                                class="author-name"
                                *ngIf="manager?.fname"
                                [ngClass]="{ 'left-margin': isLast && getManagersWithoutAuthor(file).length > 1 }"
                                [matTooltip]="manager?.fname + ' ' + manager?.lname"
                                >{{ manager?.fname | nameSign }}{{ manager?.lname | nameSign }}</span
                            >
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="getManagersWithoutAuthor(file).length > 2">
                        <span [matTooltip]="getManagersTooltip(getManagersWithoutAuthor(file))" class="author-name">{{
                            getManagersWithoutAuthor(file).length
                        }}</span>
                    </ng-container>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="id">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Id</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Id:</span>
                <div [matTooltip]="file.priority" class="id-column">
                    <span>{{ file.id }}</span>
                    <span *ngIf="significantPrio.includes(file.priority)" class="prio {{ file.priority }}">*</span>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="priority">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Priority</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Priority:</span>
                <app-item-change-on-the-fly
                    class="customer-item-not-task {{ file.priority }}"
                    [capitalize]="true"
                    [selectionOptions]="filePrioOptions"
                    [value]="file.priority"
                    (onValueChange)="onSelectPriority(file, $event)"
                ></app-item-change-on-the-fly>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tools">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell class="btns-actions" *matCellDef="let file">
                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); createMaterial(file)"
                    matTooltip="Create material"
                    mat-icon-button
                    i18n-matTooltip="@@createMaterial"
                    class="creat-mat"
                >
                    <mat-icon
                        fxFlex="0 0 auto"
                        color="primary"
                        fontSet="klickdata"
                        fontIcon="kd-icon-document"
                        class="course-plan-icon kd-icon-24 no-shadow"
                    ></mat-icon>
                </button>

                <div fxHide.gt-sm class="download-wrapper">
                    <span class="files-count">{{ file.medias?.file?.length }}</span>
                    <button
                        (click)="$event.stopPropagation(); download(file)"
                        matTooltip="Download"
                        mat-icon-button
                        i18n-matTooltip="@@download"
                        class="comment-add"
                    >
                        <mat-icon>file_download</mat-icon>
                    </button>
                </div>

                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); edit(file)"
                    [disabled]="!authUser?.canEditMedia(file)"
                    matTooltip="Edit"
                    mat-icon-button
                    i18n-matTooltip="@@edit"
                    class="comment-add"
                >
                    <mat-icon>edit</mat-icon>
                </button>
                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); delete(file)"
                    matTooltip="Delete"
                    mat-icon-button
                    i18n-matTooltip="@@delete"
                    class="comment-add"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let file; columns: columns" class="example-element-row"></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
</div>

<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center" class="spinner-container mt-2">
        <mat-spinner fxFlex="0 0 auto"></mat-spinner>
    </div>
</ng-template>
